const styles = {
    application: {
        marginBottom: 15
    },
    link: {
        textDecoration: "none"
    }
};

export default styles;


// WEBPACK FOOTER //
// src/containers/common/DashboardPage/DashboardPage.css.js